import { Link } from 'react-router-dom';
import { BookOpen, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface PillarPageBacklinkProps {
  variant: 'banner' | 'card';
}

const PillarPageBacklink = ({ variant }: PillarPageBacklinkProps) => {
  if (variant === 'banner') {
    return (
      <div className="mb-8 rounded-lg border border-primary/20 bg-primary/5 px-5 py-3 flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-2 text-sm text-foreground">
          <BookOpen className="h-4 w-4 text-primary flex-shrink-0" />
          <span>
            Part of our complete guide:{' '}
            <Link to="/aging-in-place" className="font-semibold text-primary hover:underline">
              The Complete Guide to Aging in Place Safely
            </Link>
          </span>
        </div>
        <Button variant="ghost" size="sm" asChild className="text-primary">
          <Link to="/aging-in-place">
            Read the Guide <ArrowRight className="ml-1 h-3 w-3" />
          </Link>
        </Button>
      </div>
    );
  }

  return (
    <div className="my-12 rounded-xl border-2 border-primary/20 bg-primary/5 p-6 md:p-8">
      <div className="flex items-start gap-4">
        <div className="hidden sm:flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 flex-shrink-0">
          <BookOpen className="h-6 w-6 text-primary" />
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-bold text-foreground mb-2">
            Read Our Complete Guide
          </h3>
          <p className="text-muted-foreground mb-4 leading-relaxed">
            This article is part of <strong>The Complete Guide to Aging in Place Safely</strong> — 
            our comprehensive resource covering room-by-room home safety, fall prevention, 
            wellness tracking, and practical steps to stay independent at home.
          </p>
          <Button asChild>
            <Link to="/aging-in-place">
              Read the Full Guide <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PillarPageBacklink;
